export const ProductStatus = {
  Inactive: 'inactive',
  Sellable: 'sellable',
  Preview: 'preview',
  Discontinued: 'discontinued',
  Stopped: 'stopped',
  Replacement: 'replacement',
  BundleOnly: 'bundleOnly',
  Test: 'test'
};
